import { createColumnHelper } from "@tanstack/react-table";
import { UTCToDateTimeFormat } from "../../../../shared";
import {
  emptyString,
  tableColumns,
  ACTIVITY_LOG_COLUMN_HEADERS,
  ACTIVITY_LOG_MESSAGE_DELIMITER,
} from "../../constants";

const columnHelper = createColumnHelper();

export const ACTIVITY_LOGS_COLUMNS = [
  columnHelper.accessor("createdAt", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.DATE_TIME,
    cell: ({ row }) => {
      return row.original.createdAt
        ? UTCToDateTimeFormat(row.original.createdAt)
        : emptyString;
    },
  }),
  columnHelper.accessor("userName", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.USER_NAME,
    size: tableColumns.SIZE_200,
  }),
  columnHelper.accessor("userType", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.USER_TYPE,
  }),
  columnHelper.accessor("brandId", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.BRAND_ID,
  }),
  columnHelper.accessor("brandName", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.BRAND_NAME,
  }),
  columnHelper.accessor("message", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.ACTION,
    cell: (row) => (
      <p title={row.getValue()} className="text-truncate text-truncate-30ch">
        {String(row.getValue()).split(ACTIVITY_LOG_MESSAGE_DELIMITER)[0]}
      </p>
    ),
  }),
  columnHelper.accessor("level", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.LOG_TYPE,
  }),
  columnHelper.accessor("exception", {
    header: ACTIVITY_LOG_COLUMN_HEADERS.LOG_DETAIL,
  }),
];
